<template>
  <div
    class="bg-surface-default-mid border-static-default-low -mx-24 border-b px-24 pb-12 lg:hidden"
    :class="{ 'sticky top-[63px]': isResponsiveComparisonEnabled }"
  >
    <RevToggle
      class="flex justify-between"
      :model-value="model"
      position="right"
      @update:model-value="handleToggle"
    >
      <div class="text-action-default-hi flex items-center space-x-8">
        <IconCompare />
        <span class="body-1-bold">{{ i18n(translations.compareDevices) }}</span>
      </div>
    </RevToggle>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevToggle } from '@ds/components/Toggle'
import { IconCompare } from '@ds/icons/IconCompare'

import translations from './ProductComparisonResponsiveToggle.translations'

const i18n = useI18n()
const { trackClick } = useTracking()
const route = useRoute()
const emit = defineEmits(['toggle'])

const { isResponsiveComparisonEnabled } = defineProps<{
  isResponsiveComparisonEnabled: boolean
}>()

const model = ref(isResponsiveComparisonEnabled)

function handleToggle(value: boolean) {
  emit('toggle', value)
  trackClick({
    name: value ? 'activate_comparison' : 'deactivate_comparison',
    zone: 'comparison_toggle',
    slugV2: route.params.slugV2,
  })
}
</script>
